import { AbstractAuditable } from "./abstractAuditable";
import { TaxRate } from "./taxRate";

export class TaxRateTable extends AbstractAuditable {
    id: string;
    merchantId: number;
    rates: Array<TaxRate>;

    constructor() {
        super();
        this.rates = new Array();
    }
}